<template>
  <div class="ui basic segment" style="overflow-x: scroll;">
    <table class="ui basic celled table" cellpadding="0" cellspacing="0">
      <thead>
      <tr class="active">
        <th rowspan="3" width="2%"><div class="headTable">№ п/п</div></th>
        <th rowspan="3" width="20%"><div class="headTable">Тема (раздел) дисциплины, курсовая работа (проект), промежуточная аттестация</div></th>
        <th rowspan="3" width="2%"><div class="verticalText">Семестр</div></th>
        <th colspan="11" width="24%"><div class="headTable">Виды контактной работы и трудоемкость (в академических часах)</div></th>
        <th rowspan="3" width="5%"><div class="headTableInt">Контроль (в академических часах)</div></th>
        <th rowspan="3" width="5%"><div class="headTableInt">Самостоятельная работа (в академических часах)</div></th>
        <th rowspan="3" width="20%"><div class="headTable">Формы текущего контроля успеваемости</div></th>
      </tr>
      <tr>
        <th width="3%" colspan="2"><div class="headTable">Л</div></th>
        <th width="3%" colspan="2"><div class="headTable">ПЗ</div></th>
        <th width="3%" colspan="2"><div class="headTable">ЛЗ</div></th>
        <th width="3%" rowspan="2"><div class="verticalText">У</div></th>
        <th width="3%" rowspan="2"><div class="verticalText">С</div></th>
        <th width="3%" rowspan="2"><div class="verticalText">ИКР</div></th>
        <th width="3%" rowspan="2"><div class="verticalText">КТО</div></th>
        <th width="3%" rowspan="2"><div class="verticalText">КЭ</div></th>
      </tr>
      <tr>
        <th width="3%"><div class="verticalText">всего</div></th>
        <th width="3%"><div class="verticalText">в виде ПП</div></th>
        <th width="3%"><div class="verticalText">всего</div></th>
        <th width="3%"><div class="verticalText">в виде ПП</div></th>
        <th width="3%"><div class="verticalText">всего</div></th>
        <th width="3%"><div class="verticalText">в виде ПП</div></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for = "theme in o_themes_props">
        <td>{{theme.num}}</td>
        <td>{{theme.name}}</td>
        <td>{{theme.period}}</td>
        <td>{{theme.lecture}}</td>
        <td>{{theme.lecture_pp}}</td>
        <td>{{theme.practice}}</td>
        <td>{{theme.practice_pp}}</td>
        <td>{{theme.laboratory}}</td>
        <td>{{theme.laboratory_pp}}</td>
        <td>{{theme.lesson}}</td>
        <td>{{theme.seminar}}</td>
        <td>{{theme.ikr}}</td>
        <td>{{theme.kto}}</td>
        <td>{{theme.ke}}</td>
        <td>{{theme.control}}</td>
        <td>{{theme.indep_work}}</td>
        <td>{{theme.control_form}}</td>
      </tr>
      <tr>
        <td colspan="3"></td>
        <td colspan="2">{{o_lectureTime}}</td>
        <td colspan="2">{{o_practiceTime}}</td>
        <td colspan="2" >{{o_laboratoryTime}}</td>
        <td>{{o_lessonTime}}</td>
        <td>{{o_seminarTime}}</td>
        <td>{{o_ikrTime}}</td>
        <td>{{o_ktoTime}}</td>
        <td>{{o_keTime}}</td>
        <td>{{o_controlTime}}</td>
        <td>{{o_indepTime}}</td>
        <td colspan="2"></td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script >
import dataRpdMixin from "../mixins/dataRpdMixin";
import dataMixin from "../mixins/dataMixin";
import computedMixin from "../mixins/computedMixin";
import tableOperationMixin from "../mixins/tableOperationMixin";
export default {
  name: "StructSPO",
  mixins: [dataMixin, dataRpdMixin, computedMixin, tableOperationMixin],
  props: {
    o_themes_props: Array,
  },
  data: () => ({

  }),
  methods: {}
}
</script>
<style scoped>

.verticalText
{
  text-align: center;
  vertical-align: middle;
  -webkit-transform: rotate(-90deg);
  -moz-transform: rotate(-90deg);
  line-height: 1;
  width: 20px;
}

.headTable
{
  text-align: center;
  vertical-align: top;
  overflow-wrap: break-word;
}

.headTableInt
{
  text-align: center;
  vertical-align: top;
  overflow-wrap: break-word;
  word-wrap: break-word;
  width: 70px;
}
</style>